// HTML block
"use strict";
var blockNames = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "meta",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
var attrName = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var unquoted = "[^\"'=<>`\\x00-\\x20]+";
var singleQuoted = "'[^']*'";
var doubleQuoted = '"[^"]*"';
var attrValue = "(?:" + unquoted + "|" + singleQuoted + "|" + doubleQuoted + ")";
var attribute = "(?:\\s+" + attrName + "(?:\\s*=\\s*" + attrValue + ")?)";
var openTag = "<[A-Za-z][A-Za-z0-9\\-]*" + attribute + "*\\s*\\/?>";
var closeTag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + openTag + "|" + closeTag + ")");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [
    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
    [/^<!--/, /-->/, true],
    [/^<\?/, /\?>/, true],
    [/^<![A-Z]/, />/, true],
    [/^<!\[CDATA\[/, /\]\]>/, true],
    [
        new RegExp("^</?(" + blockNames.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"), /^$/, false]
];
export function html_block_div_align(state, startLine, endOfStringLine, silent) {
    var _a;
    var i;
    var endLine;
    var token;
    var lineText;
    var pos = state.bMarks[startLine] + state.tShift[startLine];
    var max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) {
        return false;
    }
    if (!state.md.options.html) {
        return false;
    }
    if (state.src.charCodeAt(pos) !== 0x3c /* < */) {
        return false;
    }
    lineText = state.src.slice(pos, max);
    // find the matching regex
    for (i = 0; i < HTML_SEQUENCES.length; i++) {
        if (HTML_SEQUENCES[i][0].test(lineText)) {
            break;
        }
    }
    if (i === HTML_SEQUENCES.length) {
        return false;
    }
    if (silent) {
        // true if this sequence can be a terminator, false otherwise
        return HTML_SEQUENCES[i][2];
    }
    endLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!HTML_SEQUENCES[i][1].test(lineText)) {
        var openingTag = (_a = /<([A-Za-z][A-Za-z0-9-]*)(\s[^>]*)?>/g.exec(lineText)) === null || _a === void 0 ? void 0 : _a[1];
        for (; endLine < endOfStringLine; endLine++) {
            var closingTagOnLine = (new RegExp("<\\/" + openingTag + "\\s*>", "g")).test(lineText);
            if (closingTagOnLine) {
                break;
            }
            else {
                pos = state.bMarks[endLine] + state.tShift[endLine];
                max = state.eMarks[endLine];
                lineText = state.src.slice(pos, max);
            }
        }
    }
    var content = state.getLines(startLine, endLine, state.blkIndent, true);
    var dom = new DOMParser().parseFromString(content, "text/html");
    var tag = dom.body.firstChild;
    var innerContent = tag == null ? "" : tag.innerHTML.trim();
    state.line = endLine;
    if (tag.tagName.toLowerCase() === "div") {
        // For divs, we want to parse the inner content as markdown
        // ignoring the containing div tag
        // but passing the div's attributes to the HTML elements inside
        var attrs_1 = tag.attributes;
        var tempTokens = [];
        state.md.block.parse(innerContent, state.md, state.env, tempTokens);
        tempTokens.forEach(function (t) {
            if (t.type !== 'inline' && t.type.endsWith('_open')) {
                if (attrs_1[0].value.includes('text-align')) {
                    var textAlign = attrs_1[0].value
                        .replace('text-align:', '')
                        .replace(';', '')
                        .trim();
                    t.attrJoin("align", textAlign);
                }
            }
            state.tokens.push(t);
        });
    }
    else {
        token = state.push("html_block_open", "", 1);
        token.meta = { tag: tag.tagName, attrs: Array.from(tag.attributes) };
        token.map = [startLine, state.line];
        token = state.push("inline", "", 0);
        token.map = [startLine, endLine];
        token.content = innerContent;
        token.children = [];
        token = state.push("html_block_close", "", -1);
        token.meta = { tag: tag.tagName };
    }
    return true;
}
